import { render, staticRenderFns } from "./LayoutShowBuildingsTab.vue?vue&type=template&id=80a65004"
import script from "./LayoutShowBuildingsTab.vue?vue&type=script&lang=ts"
export * from "./LayoutShowBuildingsTab.vue?vue&type=script&lang=ts"
import style0 from "./LayoutShowBuildingsTab.vue?vue&type=style&index=0&id=80a65004&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports